var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import { CREATE_PROJECT_PRODUCT } from 'root/src/shared/descriptions/endpoints/endpointIds';
import { redesignApiFetch } from 'root/src/client/v2/_pages/add-campaign/redesign/lib/redesignDareDropApi';
import { buildCreateBrandDarePayload, brandDareErrorMessage } from 'root/src/client/v2/_pages/drop/redesign/brandDare';
export const getCreateBrandDareErrorMessage = (error) => {
    var _a;
    return ((_a = brandDareErrorMessage(error)) !== null && _a !== void 0 ? _a : (error instanceof Error ? error.message : 'Could not create the dare, please try again.'));
};
// Brand/admin "dare a creator": assigns an existing drop dare to one or more creators. One project is
// created holding every picked creator as an assignee, which is what the legacy /create-brand-project
// form did through this same endpoint.
// Routed through `redesignApiFetch` like every other redesign call to a legacy gateway endpoint: it
// sends `application/json` (needed against the local API) and puts the gateway error envelope on the
// thrown error's `cause`, which is where the readable-message mapping reads the error code from.
export const useCreateBrandDare = () => useMutation({
    mutationKey: ['redesign', CREATE_PROJECT_PRODUCT],
    retry: false,
    mutationFn: (params) => __awaiter(void 0, void 0, void 0, function* () {
        return redesignApiFetch(CREATE_PROJECT_PRODUCT, buildCreateBrandDarePayload(params));
    }),
});
